
import React from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { ArrowRight, Disc } from 'lucide-react';
import Logo from './Logo';

const Hero: React.FC = () => {
  const { scrollY } = useScroll();
  const y1 = useTransform(scrollY, [0, 500], [0, 150]);
  const opacity = useTransform(scrollY, [0, 400], [1, 0]);

  return (
    <section className="relative min-h-screen flex items-center justify-center pt-20 overflow-hidden">
      {/* Cinematic Background */}
      <div className="absolute inset-0 z-0">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[90vw] h-[90vw] bg-gold/5 rounded-full blur-[120px] animate-pulse" />
        <div className="absolute inset-0 aurora-bg opacity-30" />
        <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/stardust.png')] opacity-10 pointer-events-none" />
      </div>

     
      <div className="container mx-auto px-6 relative z-10 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
          className="inline-flex items-center space-x-2 px-4 py-1.5 glass rounded-full mb-12 border-gold/10"
        >
          <span className="w-2 h-2 bg-gold rounded-full animate-pulse" />
          <span className="text-[10px] md:text-xs font-bold tracking-[0.3em] uppercase text-gold/80">DJ Évènementiel & Clubbing</span>
        </motion.div>

        <motion.div
          style={{ y: y1, opacity }}
          initial={{ scale: 0.9, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 1.2, ease: [0.16, 1, 0.3, 1] }}
          className=" flex justify-center"
        >
          <Logo className="w-64 md:w-[32rem] lg:w-[42rem]" showGlow={false} />
          {/* Scroll Indicator */}
         

        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 2, duration: 1 }}
          className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center space-y-2 opacity-30"
        >
          {/*<span className="text-[10px] uppercase tracking-[0.3em] font-bold">Scroll</span>*/}
          <motion.div
            animate={{ y: [0, 10, 0] }}
            transition={{ duration: 2, repeat: Infinity }}
            className="w-px h-12 bg-gradient-to-b from-gold to-transparent"
          />
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1.5, delay: 0.8 }}
          className="space-y-12"
        >
         
          <p className="max-w-3xl mx-auto text-lg md:text-2xl text-white/60 font-light leading-relaxed">
            Basé dans le sud de la France,  je fais vibrer les dancefloors avec une signature afro-urbaine ainsi que des sets open format,
            <br></br>capables de s’adapter du club aux événements privés,
            <br></br>en passant par les mariages.
          </p>

         


          <div className="flex flex-col md:flex-row items-center justify-center gap-6">
            <a
              href="#contact"
              className="group relative px-12 py-6 bg-gold text-dark rounded-full font-bold uppercase tracking-[0.2em] text-[10px] overflow-hidden transition-all duration-300 hover:scale-105 shadow-[0_0_30px_rgba(180,133,5,0.3)]"
            >
              <span className="relative z-10 flex items-center">
                Contacter DJ Saff <ArrowRight className="ml-2 w-4 h-4 group-hover:translate-x-1 transition-transform" />
              </span>
              <div className="absolute inset-0 bg-white translate-y-full group-hover:translate-y-0 transition-transform duration-300" />
            </a>
            
            <a
              href="#music"
              className="group px-12 py-6 glass text-white rounded-full font-bold uppercase tracking-[0.2em] text-[10px] flex items-center transition-all duration-300 hover:bg-white/10"
            >
              Écouter les sets <Disc className="ml-2 w-4 h-4 group-hover:rotate-180 transition-transform duration-700" />
            </a>
          </div>
        </motion.div>
      </div>

    
    </section>
  );
};

export default Hero;
